import { pdfCustomFieldsTranslations } from './pdf-custom-fields-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
/** Translations of the visual PDF template designer; wired up in lib/i18n/en.ts. */
export const pdfDesignerFr = {
  customFields: pdfCustomFieldsTranslations.fr,
  list: {
    title: 'Modèles PDF',
    subtitle:
      'Concevez des mises en page de documents sans codage et attribuez-les par type de document.',
    cardTitle: 'Modèles',
    cardDescription:
      "Le modèle par défaut d'un type de document est appliqué automatiquement à l'impression.",
    filter: 'Filtrer le type de document',
    allTypes: 'Tous types de documents',
    create: 'Nouveau modèle',
    created: 'Le modèle a été créé.',
    createTitle: 'Créer un modèle',
    createDescription:
      'Choisissez un type de document et une mise en page de départ ; les deux restent modifiables.',
    preset: 'Disposition de départ',
    presetHint:
      'Le préréglage définit les marges, les polices, les blocs de construction et les colonnes.',
    active: 'Actif',
    inactive: 'Inactif',
    error: "Les modèles n'ont pas pu être chargés.",
    emptyTitle: "Aucun modèle pour l'instant",
    emptyHint: "Créez un modèle pour concevoir la mise en page d'impression de vos documents.",
    columns: {
      name: 'Nom',
      documentType: 'Type de document',
      status: 'Statut',
      updatedAt: 'Dernière modification',
    },
  },
  documentTypes: {
    QUOTE: 'Devis',
    ORDER: 'Confirmation de commande',
    DELIVERY_NOTE: 'Bon de livraison',
    INVOICE: 'Facture',
    PURCHASE_ORDER: 'Bon de commande',
    ALL: 'Tous types de documents',
  },
  presets: {
    CLASSIC_DIN5008: 'Classique DIN 5008',
    MODERN_MINIMALIST: 'Minimaliste moderne',
    COMPACT: 'Compacte',
  },
  blocks: {
    RECEIVING_HOURS: deliveryPlanningTranslations.fr.receiving,
    TRANSPORT_PLAN: deliveryPlanningTranslations.fr.transport,
    LOGO: "Logo de l'entreprise",
    SENDER_LINE: "Ligne de l'expéditeur",
    RECIPIENT_ADDRESS: "Champ d'adresse",
    DOCUMENT_META: 'Zone de données du document',
    HEADER_TEXT: "Ligne d'objet",
    CUSTOMER_HEADER: "Données client dans l'en-tête",
    ITEMS_TABLE: 'Tableau des éléments de campagne',
    SHIPPING_SUMMARY: 'Conditionnements et poids',
    TOTALS_BLOCK: 'Bloc de totaux',
    GIROCODE_QR: 'GiroCode QR',
    FOOTER_TEXT: 'Conditions de paiement',
    FOOTER_COLUMNS: 'Pied de page à trois colonnes',
    CUSTOM_HTML_TEXT: 'Texte libre',
  },
  columns: {
    position: 'Objet',
    sku: "Numéro d'article",
    name: 'Description',
    description: 'Détails',
    batchNumber: 'Lot',
    expiryDate: 'À consommer de préférence avant',
    quantity: 'Quantité',
    unit: 'Unité',
    unitPrice: 'Prix unitaire',
    discountPercent: 'Remise',
    taxRate: 'Taux de TVA',
    lineTotal: 'Total net',
  },
  toolbar: {
    name: 'Nom du modèle',
    isDefault: 'Par défaut',
    unsaved: 'Modifications non enregistrées',
    editMode: 'Mode édition',
    previewMode: 'Aperçu PDF en direct',
    undo: 'Annuler',
    redo: 'Refaire',
    resetPreset: 'Réinitialiser au préréglage',
    duplicate: 'Dupliquer',
    setDefault: 'Définir par défaut',
    save: 'Enregistrer et activer',
  },
  library: {
    title: 'Éléments de base',
    usedTitle: 'Blocs utilisés',
    add: 'Ajouter {{block}}',
  },
  canvas: {
    dragHandle: 'Déplacer le bloc',
    hide: 'Masquer le bloc',
    show: 'Afficher le bloc',
    remove: 'Supprimer le bloc',
    empty: 'Faites glisser les blocs de construction de la colonne de gauche vers la page.',
    resizeColumn: 'Ajuster la largeur de la colonne {{column}}',
    customerHeaderConfigured: 'Champs de la mise en page enregistrée du document',
    customerHeaderFields: '{{count}} champs client sélectionnés',
  },
  inspector: {
    pageTitle: 'Page',
    marginsTitle: 'Marges de page (mm)',
    margin: {
      top: 'Haut',
      bottom: 'Bas',
      left: 'Gauche',
      right: 'Droite',
    },
    typographyTitle: 'Typographie',
    fontFamily: 'Famille de polices',
    baseFontSize: 'Taille de base (pt)',
    lineHeight: 'Hauteur de ligne',
    colorsTitle: 'Couleurs',
    primaryColor: 'Couleur primaire',
    secondaryColor: 'Couleur secondaire',
    textColor: 'Couleur du texte',
    din5008Title: 'DIN 5008',
    showFoldMarks: 'Afficher les marques de pli',
    showPunchMark: 'Afficher la marque de pointage',
    showPageNumbers: 'Afficher les numéros de page',
    visible: 'Visible',
    pageBreakBefore: 'Saut de page avant',
    content: 'Texte',
    contentHint: 'Laissez vide pour utiliser le texte capturé sur le document.',
    positionTitle: 'Position et espacement',
    positionX: 'X (mm)',
    positionY: 'O (mm)',
    positionWidth: 'Largeur (mm)',
    positionHeight: 'Hauteur (mm)',
    paddingTop: 'Espace au-dessus (mm)',
    paddingBottom: 'Espace en dessous (mm)',
    styleTitle: 'Apparence',
    fontSize: 'Taille de la police (pt)',
    alignLabel: 'Alignement',
    bold: 'Gras',
    borderBottom: 'Règle du bas',
    background: "Couleur d'arrière-plan",
    align: {
      left: 'Gauche',
      center: 'Centre',
      right: 'Droite',
    },
    tableDisplayTitle: 'Apparence du tableau',
    zebra: 'Rayures zébrées',
    compact: 'Espacement des rangs compact',
    headerBackground: "Teinter la ligne d'en-tête",
    headerColor: "Couleur d'en-tête",
    columnsTitle: 'Colonnes',
    columnLabel: 'Étiquette',
    totalsTitle: 'Bloc de totaux',
    showTaxBreakdown: 'Afficher le détail de la TVA',
    showCashDiscount: "Afficher l'escompte",
    girocodeTitle: 'GiroCode',
    qrSize: 'Taille (mm)',
    qrAlign: 'Alignement',
    qrCaption: 'Afficher la légende',
    logoTitle: 'Logo',
    logoHeight: 'Hauteur (mm)',
    showCompanyAddress: "Afficher l'adresse de l'entreprise",
    paymentTitle: 'Avis',
    showPaymentTerms: 'Afficher les conditions de paiement',
    showTaxNotice: "Afficher l'avis d'imposition",
    customerHeaderTitle: 'Données client',
    customerHeaderHint:
      'Les champs standard publics sélectionnés, comme le n° de TVA, affichent la valeur enregistrée du document. Ajouter un champ active le bloc. Les champs personnalisés exigent toujours leur autorisation PDF.',
    customerHeaderSharedTypeHint:
      'Ce modèle couvre plusieurs types de documents. Les champs absents ou non autorisés sont omis en toute sécurité.',
    customerHeaderColumns: 'Colonnes',
    customerHeaderLabels: 'Libellés des champs',
    customerHeaderLayoutDefault: 'Utiliser la mise en page du document',
    customerHeaderLabelsShow: 'Toujours afficher',
    customerHeaderLabelsHide: 'Valeurs uniquement',
    customerHeaderHideEmpty: 'Masquer les valeurs vides',
    customerHeaderFields: 'Sélection des champs',
    customerHeaderUseLayout: 'Utiliser la mise en page',
    customerHeaderAllConfigured:
      'Tous les champs autorisés pour le PDF dans le document sont affichés.',
    customerHeaderSelectedCount: '{{count}} champs sélectionnés explicitement',
    customerHeaderSelected: 'Champs client sélectionnés',
    customerHeaderUnavailableField: "Champ qui n'est plus disponible",
    customerHeaderMoveUp: 'Déplacer le champ vers le haut',
    customerHeaderMoveDown: 'Déplacer le champ vers le bas',
    customerHeaderRemove: 'Retirer le champ de la sélection',
    customerHeaderSearch: 'Rechercher des champs ou catégories',
    customerHeaderSource: 'Filtrer le type de champ',
    customerHeaderCategory: 'Filtrer la catégorie',
    customerHeaderLoadError: 'Impossible de charger les champs client.',
    customerHeaderBlocked: 'Ce champ ne peut pas apparaître sur les PDF.',
    customerHeaderNoFields: 'Aucun champ externe autorisé ne correspond.',
  },
  meta: {
    addDocument: 'Ajouter un champ du document',
    add: 'Ajouter un champ client',
    rows: 'Lignes des données du document',
    hint: 'Déplacez les lignes ou utilisez les flèches. Les valeurs, libellés et autorisations PDF proviennent du document enregistré. La zone grandit avec le contenu ; vérifiez sa taille réelle dans l’aperçu PDF. Les autres blocs restent indépendants.',
    showLabel: 'Afficher le libellé',
    hideEmpty: 'Masquer les valeurs vides',
    chooseSample: 'Sélectionnez un document pour la vérification.',
    loadError: 'Impossible de charger les champs ou le document. Vérifiez vos droits de lecture.',
    emptyValue: 'Valeur vide',
    configureLayout: 'Configurer les autorisations PDF de l’en-tête client',
    configureFields: 'Configurer les champs personnalisés',
    openDocument: 'Vérifier les valeurs enregistrées dans le document',
    standard: {
      documentNumber: 'Numéro de document',
      documentDate: 'Date',
      customerNumber: 'Numéro client',
      contactPerson: 'Interlocuteur',
      reference: 'Référence',
      serviceDate: 'Date de prestation',
      deliveryDate: 'Date de livraison',
      validUntil: 'Valable jusqu’au',
      dueDate: 'Échéance',
    },
    issues: {
      documentMissingSnapshot:
        'Aucune définition historique lisible n’est disponible pour ce champ. Vérifiez les champs personnalisés et vos droits de lecture dans le document exemple. Les définitions actuelles ne les remplacent jamais.',
      documentNotReleased:
        'Ce champ n’est pas autorisé pour le PDF dans sa définition enregistrée ou actuelle. Vérifiez « Afficher dans le PDF » dans les champs personnalisés ; la sélection dans le modèle ne donne aucune autorisation.',
      unavailable:
        'Ce champ est indisponible dans le catalogue actuel. Vérifiez le type de document, l’état du champ et les droits de lecture dans les champs personnalisés.',
      missingSnapshot:
        'Aucune valeur enregistrée. Vérifiez les données client du document ; ajoutez ou actualisez explicitement le champ dans un brouillon si nécessaire. Les données actuelles ne sont jamais utilisées en remplacement.',
      notConfigured:
        'Le champ manque dans la mise en page enregistrée. Vérifiez la sélection des données client du document.',
      private:
        'Les champs internes ou confidentiels sont interdits dans les PDF. Vérifiez leur classification ; leur sélection dans un modèle n’accorde aucune autorisation.',
      notReleased:
        'Le champ ou la section n’est pas autorisé dans le PDF du document enregistré. Vérifiez ses autorisations ; configurez les valeurs par défaut des nouveaux documents dans l’en-tête client.',
      condition:
        'La condition enregistrée n’est pas remplie ou le champ est protégé. Vérifiez la configuration des données client du document.',
      empty: 'La valeur enregistrée est vide et masquée.',
    },
  },
  preview: {
    title: 'Aperçu PDF',
    sample: 'Exemple de document',
    refresh: "Recharger l'aperçu",
    updating: "Mise à jour de l'aperçu…",
    emptyTitle: 'Aucun exemple de document disponible',
    emptyHint: "Créez un document de ce type pour voir l'aperçu.",
  },
  editor: {
    loadError: "Le modèle n'a pas pu être chargé.",
    copyName: '{{name}} (copie)',
    resetTitle: 'Réinitialiser la mise en page ?',
    resetDescription:
      "Toutes les personnalisations de ce modèle sont remplacées par le préréglage « {{preset}} ». L'étape peut être annulée.",
  },
  toast: {
    saved: 'Le modèle a été enregistré.',
    duplicated: 'Le modèle a été dupliqué.',
    defaultSet: 'Le modèle est désormais le modèle par défaut pour ce type de document.',
  },
};
